import { type Ref, useImperativeHandle, useRef, useState } from "react";

import { ClientContactDialog } from "./components/ClientContactDialog";
import type { ClientContact } from "./types";

export interface ClientContactModalHandle {
  open: (
    clientId: number,
    originElement?: HTMLElement,
  ) => ClientContactModalHandle;
  hide: () => ClientContactModalHandle;
}

export type ClientContactModalProps = {
  onCreated?: (contact: ClientContact) => void;
  ref?: Ref<ClientContactModalHandle>;
};

export function ClientContactModal({
  onCreated,
  ref,
}: ClientContactModalProps) {
  const [clientId, setClientId] = useState<number | null>(null);
  const [open, setOpen] = useState(false);
  const originRef = useRef<DOMRect | null>(null);

  const handle: ClientContactModalHandle = {
    open: (nextClientId, originElement) => {
      originRef.current = originElement?.getBoundingClientRect() ?? null;
      setClientId(nextClientId);
      setOpen(true);

      return handle;
    },
    hide: () => {
      setOpen(false);

      return handle;
    },
  };

  useImperativeHandle(ref, () => handle, []);

  return (
    <ClientContactDialog
      open={open}
      onOpenChange={setOpen}
      clientId={clientId}
      onCreated={(contact) => onCreated?.(contact)}
      originRef={originRef}
    />
  );
}
